<template>
  <div class="section" :class="{
	  'section-gray': grayBackground
  }">
	<div class="section-box d-flex justify-content-space-between" :class="{
		'row-reverse': reverse,
		'section-box__boxed': boxed
	}">
		<el-image :src="imageSrc" style="width: 500px;"></el-image>
		<div class="section-box__content d-flex column justify-content-center">
			<slot />
		</div>
	</div>
  </div>
</template>

<script setup>
	defineProps({
		grayBackground: { type: Boolean, default: false },
		reverse: { type: Boolean, default: true },
		boxed: { type: Boolean, default: false },
		imageSrc: { type: String }
	})
</script>

<style scoped lang="scss">
	.section {
		padding: 0 30px;
		margin-bottom: 1.5rem;
		position: relative;
		
		&.section-gray {
			background-color: #f5f6f7;
		}
	
		.section-box {
			min-height: 100px;
			margin: 0 1rem;
			padding: 1rem;
			
			&.section-box__boxed {
				box-shadow: 0 3px 16px -2px #d0cece;
				border-radius: 30px;
			}
			
			.section-box__content {
				min-width: 50%;
			}
		}
	}
</style>
